import Http from './http'

export const getQuestSubmissions = async ({ student_id }) => {
  const data = await Http.get(`/students/${student_id}/questsubmissions`)
  return data.data
}
export const getQuestSubmission = async ({ quest_id, student_id }) => {
  const data = await Http.get(`/students/${student_id}/questsubmissions`, {
    params: { quest_id }
  })
  return data.data
}
export const createQuestSubmission = async ({ quest_id, student_id }) => {
  const data = await Http.post('/questsubmissions', { quest_id, student_id })
  return data.data
}
export const finishQuestSubmission = async ({ quest_submission_id }) => {
  const data = await Http.post('/finishedquestsubmissions', { quest_submission_id })
  return data.data
}
